import stripHTMLTags from '../../../helpers/stripHTMLTags';
import { ContainerChildrenSpace, ContainerSize } from '../../Container/consts';
import Container from '../../Container/Container';
import Section from '../../Section/Section';
import type { MagazineArticleDetailsProps } from './interfaces';
import styles from './MagazineArticleDetails.module.scss';

const MagazineArticleDetails = ({
  summaryText,
}: MagazineArticleDetailsProps) => {
  return (
    <Section hasFullWidth>
      <Container
        size={ContainerSize.Small}
        spaceBetweenChildren={ContainerChildrenSpace.None}
      >
        <div>
          <div className={styles.summaryText}>{stripHTMLTags(summaryText)}</div>
        </div>
      </Container>
    </Section>
  );
};

export default MagazineArticleDetails;
